<template>
  <Row align="middle" justify="center" style="height: 100vh">
    <Icon type="md-checkmark-circle" size="80" style="color:#19be6b;margin-bottom: 20px;margin-top: 100px " />
    <p style="font-size:18px">{{$t('global.text20')}}</p>
  </Row>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>